module.exports = {
    deliveryWindowAlerts: {
        alertTitle: 'Delivery Window Alert',
        expressDeliveryUnavailableMessage:
            'Sorry, Delivery Now is no longer available at this current time. Choose another delivery method or pickup.',
        orderLimitExceededWarningError:
            'Your cart has exceeded the limit for Delivery Now',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/delivery-window-alerts.js